
import HCLTreeEdge from '../HCLTreeEdge';
import {mxConstants} from "mxgraph-js";

class EventTreeEdge extends HCLTreeEdge {
  constructor(style: any = null) {
    const s = !style ? EventTreeEdge.getMyStyle() : style;
    super(s);
  }

  static getMyStyle() {
    const edgeStyle: any = {};
    edgeStyle.endArrow = 'classic';
    edgeStyle[mxConstants.STYLE_EDGE] = mxConstants.EDGESTYLE_ORTHOGONAL;
    edgeStyle[mxConstants.STYLE_VERTICAL_LABEL_POSITION] = mxConstants.ALIGN_BOTTOM;
    edgeStyle[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_TOP;
    edgeStyle[mxConstants.STYLE_PERIMETER_SPACING] = 0;
    edgeStyle[mxConstants.STYLE_STROKEWIDTH] = 2;
    return edgeStyle;
  }
}

export default EventTreeEdge;
